<script>
import Layout from '@layouts/main'
import api from '@utils/api'
import formatDate, { convertToUTC } from '@utils/format-date-with-time'
import eventsModel from '@/models/events'
import TablePaginator from '@components/paginator'
import { mapState } from 'vuex'
import { convertTemperature, toCelcius, convertBatteryCharge } from '@utils/converter'
import $ from 'jquery'
import userHasRoles from '@utils/userPermissions'

export default {
  name: 'InvalidEvents',
  components: { Layout, TablePaginator },
  data() {
    return {
      modelName: 'invalidEvents',
      isLoading: false,
      allowedRolesToSeeDetails: [
        'SUPERUSER',
        'DICTIONARIES_OPERATOR',
        'DOCUMENTS_OPERATOR',
        'GUEST',
      ],
      plugId: null,
      lastValidEvent: null,
      headers: [
        { text: 'id', value: 'id', sortable: true },
        { text: 'transmitterGuid', value: 'transmitterId', sortable: true },
        { text: 'plugGuid', value: 'plugId', sortable: true },
        { text: 'sigfoxId', value: 'sigfoxId', sortable: true },
        { text: 'zigbeeId', value: 'zigbeeId', sortable: true },
        { text: 'measureTime', value: 'measureTime', sortable: true },
        { text: 'receiveTime', value: 'receiveTime', sortable: true },
        { text: 'sigfoxTime', value: 'sigfoxTime', sortable: true },
        { text: 'sigfoxSeqNumber', value: 'sigfoxSeqNumber', sortable: true },
        {
          text: 'sigfoxDeviceTypeId',
          value: 'sigfoxDeviceTypeId',
          sortable: true,
        },
        { text: 'level', value: 'level', sortable: true },
        { text: 'temperature', value: 'temperature', sortable: true },
        { text: 'angleX', value: 'angleX', sortable: true },
        { text: 'angleY', value: 'angleY', sortable: true },
        {
          text: 'inclination_angle',
          value: 'inclinationAngle',
          sortable: true,
        },
        { text: 'rectXstart', value: 'rectXstart', sortable: true },
        { text: 'rectYstart', value: 'rectYstart', sortable: true },
        {
          text: 'calculated_angles_correction',
          value: 'calculatedAnglesCorr',
          sortable: true,
        },
        {
          text: 'calculated_volume_correction',
          value: 'calculatedVolumeCorr',
          sortable: true,
        },
        { text: 'calculation_comment', value: 'comment', sortable: true },
        { text: 'remain_id', value: 'remainId', sortable: true },
        { text: 'battaryCharge', value: 'batteryCharge', sortable: true },
        { text: 'wakeupReason', value: 'wakeupReason', sortable: true },
        { text: 'measureType', value: 'measureType', sortable: true },
        { text: 'corrections', value: 'corrections', sortable: true },
        { text: 'sending', value: 'sending', sortable: true },
      ],
      rowsPerPage: [25, 50, 100],
      page: 1,
      totalPages: 0,
      sortBy: 'receiveTime',
      descending: true,
      first: false,
      last: false,
      content: [],
      pagination: {},
      totalElements: 0,
      filters: {},
      model: eventsModel,
    }
  },
  computed: {
    params() {
      return {
        size: this.pagination.rowsPerPage || null,
        page: this.page || null,
        sort_property: this.sortBy || null,
        sort_direction: this.descending || null,
        ...this.filters,
      }
    },
    ...mapState({
      unitsMeasurementValue: state => state.userSettings.userSettings['unitsMeasurement'],
    }),
    unitsMeasurement() {
      return this.$store.getters['userSettings/getUnitsMeasurement']
    },
    userAllowedToNavigate() {
      return userHasRoles(
        this.$store.state.auth.userRole,
        this.allowedRolesToSeeDetails
      )
    },
  },
  watch: {
    pagination: {
      handler() {
        this.$store.commit('pagination/SET', {
          name: this.modelName,
          pagination: {
            page: this.page,
            rowsPerPage: this.pagination.rowsPerPage,
            sortBy: this.sortBy,
            descending: this.descending,
          },
        })
      },
      deep: true,
    },
  },
  created() {
    this.plugId = this.$route.params.id
    this.lastValidEvent = this.$route.params.lastValidEvent
    this.prepareFilters()
    this.getPaginator()
    this.fetchData()
  },
  updated() {
    this.updateScrollBar()
  },
  mounted() {
    let scrollWrapper = $('.scroll-wrapper')
    let fixedHeaderTable = $('.fixed-header-table').find('.table__overflow')
    fixedHeaderTable.scroll(function() {
      scrollWrapper.scrollLeft(fixedHeaderTable.scrollLeft())
    })
    scrollWrapper.scroll(function() {
      fixedHeaderTable.scrollLeft(scrollWrapper.scrollLeft())
    })
    window.addEventListener('resize', this.updateScrollBar)
  },
  destroyed() {
    window.removeEventListener('resize', this.updateScrollBar)
  },
  methods: {
    updateScrollBar() {
      let fixedHeaderTable = $('.fixed-header-table')
      $('.scroll-inner')
        .width(fixedHeaderTable.find('.datatable')[0].scrollWidth)
        .height(20)
      $('.scroll-wrapper').width(
        fixedHeaderTable.find('.table__overflow').width() - 5
      )
    },
    prepareFilters() {
      this.filters['filter_plugId_value'] = this.plugId
      this.filters['filter_plugId_comparison'] = 'EQ'
      if (this.lastValidEvent) {
        this.filters['filter_id_value'] = this.lastValidEvent
        this.filters['filter_id_comparison'] = 'GT'
      }
    },
    fetchData() {
      this.isLoading = true
      api
        .getItems('event/v2/invalid', this.params)
        .then(response => {
          this.content = response.content
          this.updatePagination(response)
        })
        .catch(() => {})
        .then(() => {
          this.isLoading = false
        })
    },
    updatePagination(response) {
      this.totalPages = response.totalPages
      this.first = response.first
      this.last = response.last
      this.page = response.number + 1
      this.pagination = {
        ...this.pagination,
        page: 1,
        rowsPerPage: response.size,
        sortBy: this.sortBy,
        descending: this.descending,
      }
    },
    convertDateParamsToFilters() {
      Object.keys(this.params).forEach(key => {
        if (key === 'selected_time') {
          this.params[`filter_${this.params.selected_time.code}_value`] =
            convertToUTC(this.params.start_date) +
            '|' +
            convertToUTC(this.params.end_date)
          this.params[`filter_${this.params.selected_time.code}_comparison`] =
            'BETWEEN'
          delete this.params.start_date
          delete this.params.end_date
          delete this.params.selected_time
        }
      })
    },
    convertUnitMeasurements(params) {
      let convertedParams = { ...params }
      if (convertedParams['filter_level_value']) {
        convertedParams['filter_level_value'] = (
          convertedParams['filter_level_value'] *
          this.unitsMeasurement.lengthMultiplier
        ).toFixed(2)
      }
      if (
        convertedParams['filter_temperature_value'] &&
        this.unitsMeasurementValue === 'us'
      ) {
        convertedParams['filter_temperature_value'] = toCelcius(
          convertedParams['filter_temperature_value']
        )
      }
      return convertedParams
    },
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value
      )
    },
    getVolume(volume) {
      if (volume && volume > 0) {
        const vol = (volume / this.unitsMeasurement.volumeMultiplier).toFixed(2)
        return vol
          .toString()
          .concat(
            this.unitsMeasurement.volumeMeasure === 'liters' ? 'L' : 'gal'
          )
      }
    },
    getPaginator() {
      const pagination = this.$store.getters['pagination/get'](this.modelName)
      if (pagination) {
        this.page = pagination.page || 1
        this.sortBy = pagination.sortBy || this.sortBy
        this.descending = pagination.descending || false
        this.pagination.page = 1
        this.pagination.rowsPerPage = pagination.rowsPerPage || 10
      } else {
        this.page = 1
        this.pagination.page = 1
        this.pagination.rowsPerPage = 10
      }
    },
    changePage(value) {
      this.page = value
      this.fetchData()
    },
    changeRowsPerPage(value) {
      if (this.pagination.rowsPerPage === value) return
      this.pagination = {
        ...this.pagination,
        rowsPerPage: value,
      }
      this.page = 1
      this.$store.dispatch('pagination/saveRowsPerPage', value)
      this.fetchData()
    },
    changeSort(header) {
      if (!header.sortable) return
      if (this.sortBy === header.value) {
        this.descending = !this.descending
      } else {
        this.sortBy = header.value
        this.descending = false
      }
      this.fetchData()
    },
    getSortClass(header) {
      return [
        header.sortable ? 'column sortable' : null,
        this.pagination.descending ? 'desc' : 'asc',
        header.value === this.pagination.sortBy ? 'active' : '',
      ]
    },
    headerToWrap(header) {
      return (
        header.text.includes('rectXstart') ||
        header.text.includes('rectYstart') ||
        header.text.includes('battaryCharge') ||
        header.text.includes('corr_rep') ||
        header.text.includes('wakeupReason') ||
        header.text.includes('measureType') ||
        header.text.includes('calculate') ||
        header.text.includes('inclination_angle')
      )
    },
    getHeaderAlign(header) {
      if (this.headerToWrap(header)) {
        let styleResult = {
          'white-space': 'pre-line',
          display: 'inline-block',
        }
        if (header.text.includes('calculate')) {
          styleResult = { ...styleResult, 'min-width': '95px' }
        }
        return styleResult
      }
      return {}
    },
    getIconCentered(header) {
      return this.headerToWrap(header) ? { 'vertical-align': 'super' } : {}
    },
    justifyPadding(header) {
      return this.headerToWrap(header)
        ? {
            'text-align': 'left',
            'padding-left': '8px',
            'padding-right': '12px',
          }
        : {
            'text-align': 'left',
            'padding-left': '8px',
            'padding-right': '8px',
          }
    },
    dateFormat(date) {
      const formatedDate = formatDate(date)
      return formatedDate === 'Invalid Date' ? '' : formatedDate
    },
    convertLevel(value) {
      let number = value / this.unitsMeasurement.lengthMultiplier
      return (
        number.toFixed(2) +
        (this.unitsMeasurement.lengthMeasure === 'inches' ? '"' : ' mm')
      )
    },
    isNull(value) {
      return value === null || value === undefined
    },
    roundValue(value) {
      return value ? value.toFixed(1) : ''
    },
    convertTemperature(value) {
      return convertTemperature(value, this.unitsMeasurementValue)
    },
    convertBatteryCharge(value) {
      return convertBatteryCharge(value, this.$store.getters['userSettings/get']('batteryChargeDisplay'))
    },
  },
}
</script>

<template>
  <Layout>
    <div
      v-show="content.length > 0"
      class="scroll-wrapper">
      <div class="scroll-inner"/>
    </div>
    <v-data-table
      :headers="headers"
      :items="content"
      :pagination="pagination"
      :total-items="totalElements"
      :loading="isLoading"
      class="fixed-header-table"
      hide-actions
    >
      <template
        slot="headers"
        slot-scope="props">
        <tr>
          <th
            v-for="header in headers"
            :key="header.text"
            :class="getSortClass(header)"
            :style="justifyPadding(header)"
            @click="changeSort(header)"
          >
            <span
              :style="getHeaderAlign(header)"
            > {{ $t(`label__${header.text}`) }} </span>
            <v-icon
              v-if="header.sortable"
              :style="getIconCentered(header)"
              small>expand_less</v-icon>
          </th>
        </tr>
      </template>
      <v-progress-linear
        slot="progress"
        height="2"
        color="blue"
        background-color="#E0E0E0"
        indeterminate
      />
      <template 
        slot="items" 
        slot-scope="props">
        <tr>
          <td :class="$style.oneRowPadding">{{ props.item.id }}</td>
          <td class="text-center">
            <router-link
              v-if="props.item.transmitterId && props.item.transmitterId !=='0' && userAllowedToNavigate"
              :to="{ name: 'searchPlug', params: { serial: props.item.transmitterId , goodsGroup: 3 }}"> {{ props.item.transmitterId }}
            </router-link>
            <span v-if="props.item.transmitterId && props.item.transmitterId !=='0' && !userAllowedToNavigate">{{ props.item.transmitterId }}</span>
            <div v-if="props.item.transmitterId==='0'"/>
          </td>
          <td :class="$style.oneRowPadding">
            <router-link
              v-if="props.item.plugId && props.item.plugId!=='0' && userAllowedToNavigate"
              :to="{ name: 'searchPlug', params: { serial: props.item.plugId, goodsGroup: 2 }} ">
              {{ props.item.plugId }}
            </router-link>
            <span v-if="props.item.plugId && props.item.plugId!=='0' && !userAllowedToNavigate">
              {{ props.item.plugId }}</span>
            <div v-if="props.item.plugId==='0'"/>
          </td>
          <td :class="$style.oneRowPadding">
            <router-link
              v-if="props.item.sigfoxId && props.item.sigfoxId!=='0' && userAllowedToNavigate"
              :to="{ name: 'searchPlug', params: { serial: props.item.sigfoxId, goodsGroup: 2 }} "> {{
              props.item.sigfoxId }}
            </router-link>
            <span v-if="props.item.sigfoxId && props.item.sigfoxId!=='0' && !userAllowedToNavigate">
              {{ props.item.sigfoxId }}</span>
            <div v-if="props.item.sigfoxId==='0'"/>
          </td>
          <td>
            <div v-if="props.item.zigbeeId==='0'"/>
            <div v-if="props.item.zigbeeId && props.item.zigbeeId!=='0'"> {{ props.item.zigbeeId }}</div>
          </td>
          <td :class="$style.oneRowPadding">{{ dateFormat(props.item.measureTime) }}</td>
          <td :class="$style.oneRowPadding">{{ dateFormat(props.item.receiveTime) }}</td>
          <td :class="$style.oneRowPadding">{{ dateFormat(props.item.sigfoxTime) }}</td>
          <td :class="$style.oneRowPadding">{{ props.item.sigfoxSeqNumber }}</td>
          <td :class="$style.oneRowPadding">{{ props.item.sigfoxDeviceTypeId }}</td>
          <td :class="$style.oneRowPadding">{{ convertLevel(props.item.level) }}</td>
          <td>{{ convertTemperature(props.item.temperature) }}</td>
          <td :class="$style.oneRowPadding">{{ props.item.angleX }}</td>
          <td :class="$style.oneRowPadding">{{ props.item.angleY }}</td>
          <td>{{ roundValue(props.item.inclinationAngle) }}</td>
          <td>{{ props.item.rectXstart }}</td>
          <td>{{ props.item.rectYstart }}</td>
          <td>{{ getVolume(props.item.calculatedAnglesCorr) }}</td>
          <td>{{ getVolume(props.item.calculatedVolumeCorr) }}</td>
          <td>{{ props.item.comment }}</td>
          <td>{{ props.item.remainId }}</td>
          <td :class="$style.wrappedRowPadding">{{ convertBatteryCharge(props.item.batteryCharge) }}</td>
          <td :class="$style.wrappedRowPadding">{{ getValue("wakeupReason", props.item.wakeupReason) }}</td>
          <td :class="$style.wrappedRowPadding">{{ getValue ("measureType", props.item.measureType) }}</td>
          <td :class="$style.oneRowPadding">{{ getValue("corrections", props.item.corrections) }}</td>
          <td :class="$style.oneRowPadding">{{ getValue ("sending", props.item.sending) }}</td>
        </tr>
      </template>
    </v-data-table>
    <table-paginator
      :page="page"
      :total-pages="totalPages"
      :first="first"
      :last="last"
      :rows-per-page="pagination.rowsPerPage"
      @change-page="changePage($event)"
      @change-rows-per-page="changeRowsPerPage($event)" />
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }

  td {
    white-space: nowrap;
  }
}
.sdEditRow {
  cursor: pointer;
}
.sdBorder {
  border: 1px solid #dfdfdf;
  border-bottom: none;
}
.wrapText {
  white-space: pre-line;
}
.oneRowPadding {
  padding-right: 8px !important;
  padding-left: 8px !important;
}

.wrappedRowPadding {
  padding-right: 12px !important;
  padding-left: 8px !important;
}
</style>
